import { InputGroup } from "react-bootstrap";
import { FILTERS_POSITION_BOTTOM } from "react-bootstrap-table-next";
import styled from "styled-components";
import {
  ModalInputLabelBlack,
  ModalSelectBlack,
  ModalInputTextBlack,
  LabelGrey,
} from "../../features/RadConnStyle";

export const PageOptions = {
  page: 1,
  sizePerPage: 25,
  lastPageText: ">>",
  firstPageText: "<<",
  nextPageText: ">",
  prePageText: "<",
  showTotal: true,
  alwaysShowAllBtns: false,
  paginationTotalRenderer: (from, to, size) => (
    <span className="page-total-item">
      {/* Showing {from} to {to} of {size} Results */}
      {size > 0 ? (
        <span>
          {from}
          <span style={{ color: "var(--page-total-text-color)" }}>{" - "}</span>
          {to}
          <span style={{ color: "var(--page-total-text-color)" }}>
            {"  ( ทั้งหมด "}
          </span>
          {size}
          <span style={{ color: "var(--page-total-text-color)" }}>
            {" "}
            รายการ {")"}{" "}
          </span>
        </span>
      ) : (
        <></>
      )}
    </span>
  ),
};

export const PageOptionsPvNx = {
  page: 1,
  sizePerPage: 10,
  lastPageText: ">>",
  firstPageText: "<<",
  nextPageText: ">",
  prePageText: "<",
  showTotal: false,
  alwaysShowAllBtns: false,
  onPageChange: (page, sizePerPage) => {
    //  console.log('page', page);
    //  console.log('sizePerPage', sizePerPage);
  },
  onSizePerPageChange: (page, sizePerPage) => {
    // console.log('page', page);
    // console.log('sizePerPageChanged', sizePerPage);
  },
};

export const LabelBlack = (props) => {
  return <ModalInputLabelBlack {...props} />;
};

export const LabelTextGrey = (props) => {
  return <LabelGrey {...props} />;
};

export const InputGroupBlack = (props) => {
  return (
    <InputGroup
      {...props}
      className="mb-1"
      style={{ flex: "1", display: "flex" }}
    />
  );
};

export const FormControlBlack = (props) => {
  return <ModalInputTextBlack {...props} />;
};

export const FormSelectBlack = (props) => {
  const { fieldId, fieldValue, initValue } = props;
  // console.log(props);
  return (
    <ModalSelectBlack
      {...props}
      // defaultValue={props?.defaultValue}
    >
      {props.leadtype && props.leadtype === "all" && (
        <option key="all" value="-1" style={{ color: "var(--fore-primary)" }}>
          {props?.firstText}
        </option>
      )}

      {props.addFirstRow && props.addFirstRow === true && (
        <option
          key="all"
          value={`${initValue ?? -1}`}
          style={{ color: "var(--fore-primary)" }}
        >
          {props?.firstRowText}
        </option>
      )}

      {props.rows ? (
        props.rows.map((itx) => {
          if (fieldId)
            return (
              <option key={itx[fieldId]} value={itx[fieldId]}>
                {itx[fieldValue]}
              </option>
            );
          else
            return (
              <option
                key={itx[Object.keys(itx)[0]]}
                value={itx[Object.keys(itx)[0]]}
              >
                {itx[Object.keys(itx)[1]]}
              </option>
            );
        })
      ) : (
        <option key="ไม่พบรายการ" value="-1" style={{ color: "yellow" }}>
          All
        </option>
      )}
    </ModalSelectBlack>
  );
};

export const LabelBlackSimpleText = styled.div`
  background: var(--bg-primary);
  padding: 10px;
  color: var(--fore-primary);
`;
